import { UserType } from '@/types/UserType'

export function getAccessToken(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem('accessToken')
}

export function setAccessToken(accessToken: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('accessToken', accessToken)
}

export function removeAccessToken(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('accessToken')
}

export function getUserFromStorage(): UserType | null {
  if (typeof window === 'undefined') return null

  const rawUser = localStorage.getItem('user')
  if (!rawUser) return null

  try {
    return JSON.parse(rawUser) as UserType
  } catch {
    localStorage.removeItem('user')
    return null
  }
}

export function setUserInStorage(user: UserType): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('user', JSON.stringify(user))
}

export function removeUserFromStorage(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('user')
}

export function setSelectedTenantId(tenantId: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('selectedTenantId', tenantId)
}

export function getSelectedTenantId(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem('selectedTenantId')
}

export function removeSelectedTenantId(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('selectedTenantId')
}

export function setSelectedTenantRole(role: string): void {
  if (typeof window === 'undefined') return
  localStorage.setItem('selectedTenantRole', role)
}

export function getSelectedTenantRole(): string | null {
  if (typeof window === 'undefined') return null
  return localStorage.getItem('selectedTenantRole')
}

export function removeSelectedTenantRole(): void {
  if (typeof window === 'undefined') return
  localStorage.removeItem('selectedTenantRole')
}

export function clearAuthStorage(): void {
  removeAccessToken()
  removeUserFromStorage()
  removeSelectedTenantId()
  removeSelectedTenantRole()
}
